// Camera source selection. The agent can pick which camera to use; the choice
// is remembered (localStorage) and applied to future calls' getUserMedia, and
// can be switched live mid-call (see Conversation route).
//
// Device labels are only populated by the browser AFTER camera permission has
// been granted — so enumerate while a call is active (or right after acquiring
// media), otherwise the labels come back empty.

const CAMERA_KEY = 'prakashsoftware.agent.camera.v1';

export function getPreferredCameraId(): string | null {
  try {
    return localStorage.getItem(CAMERA_KEY) || null;
  } catch {
    return null;
  }
}

export function setPreferredCameraId(id: string | null): void {
  try {
    if (id) localStorage.setItem(CAMERA_KEY, id);
    else localStorage.removeItem(CAMERA_KEY);
  } catch {
    /* non-fatal — selection just won't persist */
  }
}

/** Video constraints for getUserMedia, honouring the remembered camera if set.
 *  Uses `ideal` (not `exact`) so a missing/unplugged device falls back to the
 *  default camera instead of failing the whole call. */
export function cameraVideoConstraints(): MediaTrackConstraints {
  const base: MediaTrackConstraints = {
    width: { ideal: 1280 },
    height: { ideal: 720 },
  };
  const id = getPreferredCameraId();
  return id ? { ...base, deviceId: { ideal: id } } : base;
}

export async function listCameras(): Promise<MediaDeviceInfo[]> {
  try {
    const devices = await navigator.mediaDevices.enumerateDevices();
    return devices.filter((d) => d.kind === 'videoinput');
  } catch {
    return [];
  }
}
